import { useState, type FormEvent } from "react";
import { KeyRound } from "lucide-react";
import { changePassword } from "../api/auth";
import { ApiError } from "../api/client";
import { Button, Card, Field } from "./ui";

/** Kartu "Ganti Kata Sandi" — dipakai di halaman Profil semua role (termasuk pasien). */
export function ChangePasswordCard() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [pwBusy, setPwBusy] = useState(false);
  const [pwError, setPwError] = useState<string | null>(null);
  const [pwOk, setPwOk] = useState<string | null>(null);

  async function onSubmitPassword(e: FormEvent) {
    e.preventDefault();
    setPwError(null);
    setPwOk(null);
    if (!current || !next) {
      setPwError("Isi kata sandi saat ini dan kata sandi baru.");
      return;
    }
    if (next.length < 8) {
      setPwError("Kata sandi baru minimal 8 karakter.");
      return;
    }
    if (next !== confirm) {
      setPwError("Konfirmasi kata sandi baru tidak cocok.");
      return;
    }
    if (next === current) {
      setPwError("Kata sandi baru harus berbeda dari kata sandi saat ini.");
      return;
    }
    setPwBusy(true);
    try {
      await changePassword({ currentPassword: current, newPassword: next });
      setCurrent("");
      setNext("");
      setConfirm("");
      setPwOk("Kata sandi berhasil diganti. Perangkat/sesi lain telah keluar otomatis.");
    } catch (err) {
      setPwError(err instanceof ApiError ? err.message : "Gagal mengganti kata sandi. Coba lagi.");
    } finally {
      setPwBusy(false);
    }
  }

  return (
    <Card>
      <h3 style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 0 }}>
        <KeyRound size={18} /> Ganti Kata Sandi
      </h3>
      <form
        onSubmit={(e) => void onSubmitPassword(e)}
        style={{ display: "flex", flexDirection: "column", gap: 10 }}
      >
        <Field
          label="Kata sandi saat ini"
          type="password"
          name="current"
          autoComplete="current-password"
          value={current}
          onChange={(e) => setCurrent(e.target.value)}
        />
        <Field
          label="Kata sandi baru"
          type="password"
          name="new"
          autoComplete="new-password"
          minLength={8}
          value={next}
          onChange={(e) => setNext(e.target.value)}
        />
        <Field
          label="Ulangi kata sandi baru"
          type="password"
          name="confirm"
          autoComplete="new-password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
        />
        {pwError ? <p className="alert alert-error">{pwError}</p> : null}
        {pwOk ? <p className="alert alert-success">{pwOk}</p> : null}
        <div>
          <Button type="submit" loading={pwBusy}>
            Simpan Kata Sandi Baru
          </Button>
        </div>
      </form>
    </Card>
  );
}
